import { axiosAuth } from "services/generic/AxiosInterceptor/AxiosInterceptor"

import { Duration } from "@shared/types/duration"

/**
 *  Helper function to create a GET request that is tied to a specific Request-Response pair.
 */
export function makeAuthGetRequest<TQueryString, TResponse>(endpoint: string, timeout?: Duration) {
  return (data: TQueryString) =>
    axiosAuth({
      url: endpoint,
      method: "get",
      params: data,
      timeout: timeout?.milliseconds,
    }).then((resp) => resp.data as TResponse)
}
